import { getLoanInfoCleanTemp } from '../../../../core/helpers/loanInfoUtils'
import { LoanInfo, OfferInfo } from '../../../../core/helpers/interfaces'


export const topNamings = {
  DEFAULT: 'A Simple, Seamless, and Secure Experience.',
  SIMPLE_SEAMLESS: 'A Simple, Seamless, and Secure Experience.',
  CANT_MAKE_AN_OFFER_TODAY: 'We can’t make you <br>an offer today. ',
}


export class OptionsStore {
  // offer info to fill select carousel; provided by API
  offersInfo: OfferInfo = {
    noAutoPay: {} as any,
    autoPay: {} as any,
    noAutoPayState: false
  }
  lastResponse: any = {}
  isPartialApproved = false

  // request payload for loan options
  loanInfo: LoanInfo = getLoanInfoCleanTemp()

  // selected offer info, after carousel;
  selectedOfferInfo: any = {}

  // show booleans
  // showMainBlock = true
  showMainBlock = true   
  showSelectBlock = false
  showMultiLoan = false
  showOffer = false
  showDentistSelect = false

  /**
   * modal-options-add-coapplicant
   */
  showCoapplicant = false

  /**
   * modal-options-partial-approved
   */
  showPartialApproved = false

  showDecline = false
  showException = false
  showCreditLock = false
  showWelcomeBack = false
  showWelcomeBackContinue = false
  
  showHawaiiMessage = false
  showMobileValidation = false
  showPartnerDown = false

  showErrorScreen = false
  showSuccess = false

  isInvalidState = false
  isInvalidStateAmount = false

  // loading wrapper control boolean
  loading = false
  // mobile number for autofill in modals
  mobile = '111-111-1111'

  // last session date for modals
  lastSessionDate: string = '10/31/2022'

  // saved loanAcctId from API response
  loanAcctId = null
  // saved approvedLoanAmount from API response
  approvedLoanAmount = null
  // saved maxApprovedLoanAmount from API response
  maxApprovedLoanAmount = null
  // saved loanId from API response
  loanId = null
  // saved userId from API response
  userId = null
  // saved loanData from API response for credit freeze
  loanData = null
  // session id from transunion, request payload part
  extFaSessionId = null
  // response from API for coapp form logic
  coboRequestId = null
  // for dentist search coapp
  coapp = null
  //
  creditData = null

  // next stp after user click continue on welcome back screen
  nextStep = null

  // naming on the top of the modal option, different between screens
  topNaming = topNamings.DEFAULT

  // full_dev related
  subStatusOnlyDev = false

  // enable dev mode:
  // selection of dev statuses in modal form;
  // skipping API depended parts
  // should be false in prod
  FULL_DEV = false
}
